// extracted by mini-css-extract-plugin
export default {"titleh2":"ChartPreview_titleh2__iz1Hh","outter_graph":"ChartPreview_outter_graph__yfkbs"};